module.exports = __webpack_public_path__ + "img/vertical_4_6_7005.0a6126b7.png";